import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * On every pathname change, scroll the window back to the very top.
 * Mounted once inside <BrowserRouter> so it sees route transitions.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Defer to next frame so layout has rendered before scrolling
    const id = requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    });
    return () => cancelAnimationFrame(id);
  }, [pathname]);

  return null;
}